<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-card-title class="elevation-0">
          <v-spacer></v-spacer>
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span style="font-family: kumbhRegular; font-size: 14px"
                  >*Select the options to filter the results</span
                >
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2>
                <v-select
                  clearable
                  v-model="financialYear"
                  :items="financialYears"
                  label="Financial Year"
                  required
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2 pt-2 pt-lg-0 pt-sm-0 pt-md-0>
                <v-text-field
                  v-model="keyword"
                  outlined
                  dense
                  hide-details
                  clearable
                  label="Search Employee"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-flex align-self-center xs12 v-if="pmrList && pmrList.length > 0" px-4 pt-3>
          <v-simple-table class="align-center">
            <template v-slot:default>
              <thead style="background-color: #005f32">
                <tr>
                  <th class="text-center pmr-th">Emp ID</th>
                  <th class="text-left pmr-th">Employee Name</th>
                  <th class="text-center pmr-th">
                    Quantitative Assessment<br />Section A Score
                  </th>
                  <th class="text-center pmr-th">
                    Qualitative Assessment<br />Section B Score
                  </th>
                  <th class="text-center pmr-th">
                    PI Rating<br />Section C Score
                  </th>
                  <th class="text-center pmr-th">Total Score</th>
                  <th class="text-center pmr-th">PMR Rating</th>
                  <th class="text-center pmr-th">Edit</th>
                  <th class="text-center pmr-th">Delete</th>
                </tr>
              </thead>
              <tbody class="align-center">
                <tr v-for="item in pmrList" :key="item._id">
                  <td class="text-center">
                    {{ item.employeeId ? item.employeeId.employeeId : "" }}
                  </td>
                  <td class="text-left">
                    <span style="font-family: kumbhMedium">
                      {{ item.employeeId ? item.employeeId.name : "" }}
                    </span>
                  </td>
                  <td class="text-center">{{ item.quantitativeScore }}</td>
                  <td class="text-center">{{ item.qualitativeScore }}</td>
                  <td class="text-center">{{ item.piRating }}</td>
                  <td class="text-center">{{ item.totalScore }}</td>
                  <td class="text-center">{{ item.rating }}</td>
                  <td class="text-center">
                    <v-icon small @click="openEdit(item)">mdi-pencil</v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      @click="(deleteDialog = true), (curitem = item._id)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
        <v-flex v-else align-self-center xs12 pa-16 text-center>
          <span class="kumbhRegular">No data found</span>
        </v-flex>
      </v-flex>

      <v-dialog persistent v-model="editDialog" max-width="600px">
        <v-card>
          <v-card-title>Edit PMR</v-card-title>
          <v-card-text>
            <div class="pb-4" style="font-family: kumbhMedium">
              {{ editName }} &middot; {{ editYear }}
            </div>
            <v-layout wrap>
              <v-flex xs12 sm6 pa-2>
                <v-text-field
                  v-model="editForm.quantitativeScore"
                  :label="`Section A - Quantitative (max ${max.quantitative})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.quantitative"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-text-field
                  v-model="editForm.qualitativeScore"
                  :label="`Section B - Qualitative (max ${max.qualitative})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.qualitative"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-text-field
                  v-model="editForm.piRating"
                  :label="`Section C - PI Rating (max ${max.pi})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.pi"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-text-field
                  :value="editTotal"
                  :label="`Total Score (max ${max.total})`"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 pa-2>
                <v-text-field
                  v-model="editForm.rating"
                  :label="`PMR Rating (max ${max.rating})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.rating"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-2>
                <v-textarea
                  v-model="editForm.reviewerComments"
                  label="Reviewer's Additional Comments"
                  outlined
                  dense
                  hide-details
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="editDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="saveEdit()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="600px">
        <v-card>
          <v-card-title>Are you sure you want to delete this data?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      appLoading: false,
      pmrList: [],
      deleteDialog: false,
      curitem: null,
      max: { quantitative: 60, qualitative: 20, pi: 20, total: 100, rating: 10 },
      editDialog: false,
      editId: null,
      editName: "",
      editYear: "",
      editForm: {
        quantitativeScore: null,
        qualitativeScore: null,
        piRating: null,
        rating: null,
        reviewerComments: "",
      },
      msg: "",
      keyword: "",
      financialYear: "",
      financialYears: [],
    };
  },
  mounted() {
    this.generateFinancialYears();
    this.getData();
  },
  computed: {
    editTotal() {
      const f = this.editForm;
      const parts = [f.quantitativeScore, f.qualitativeScore, f.piRating];
      if (parts.every((p) => p === null || p === "")) return "";
      return Math.round(parts.reduce((acc, p) => acc + (Number(p) || 0), 0) * 100) / 100;
    },
  },
  watch: {
    keyword() {
      this.getData();
    },
    financialYear() {
      this.getData();
    },
  },
  methods: {
    generateFinancialYears() {
      const now = new Date();
      // Financial year runs April - March
      const currentStart = now.getMonth() < 3 ? now.getFullYear() - 1 : now.getFullYear();
      const years = [];
      for (let y = currentStart + 1; y >= 2000; y--) {
        years.push(`${y}-${y + 1}`);
      }
      this.financialYears = years;
      // Default to the current financial year
      this.financialYear = `${currentStart}-${currentStart + 1}`;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/pmr/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          search: this.keyword,
          year: this.financialYear,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.pmrList = response.data.status ? response.data.data : [];
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    openEdit(item) {
      this.editId = item._id;
      this.editName = item.employeeId ? item.employeeId.name : "";
      this.editYear = item.fyear;
      this.editForm = {
        quantitativeScore: item.quantitativeScore,
        qualitativeScore: item.qualitativeScore,
        piRating: item.piRating,
        rating: item.rating,
        reviewerComments: item.reviewerComments || "",
      };
      this.editDialog = true;
    },
    // Returns an error message when the value is not a number in [0, max], otherwise null
    checkScore(value, max, label) {
      if (value === null || value === undefined || value === "") {
        return `Please provide ${label}`;
      }
      const n = Number(value);
      if (!Number.isFinite(n) || n < 0 || n > max) {
        return `${label} must be between 0 and ${max}`;
      }
      return null;
    },
    saveEdit() {
      const f = this.editForm;
      const error =
        this.checkScore(f.quantitativeScore, this.max.quantitative, "Quantitative Assessment score") ||
        this.checkScore(f.qualitativeScore, this.max.qualitative, "Qualitative Assessment score") ||
        this.checkScore(f.piRating, this.max.pi, "PI Rating") ||
        this.checkScore(f.rating, this.max.rating, "PMR Rating") ||
        (Number(f.rating) === 0 ? "PMR Rating must be greater than 0" : null);
      if (error) {
        this.msg = error;
        this.showsnackbar = true;
        return;
      }
      this.appLoading = true;
      axios({
        url: "/pmrscore/edit",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: { id: this.editId, ...f },
      })
        .then((response) => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status) {
            this.editDialog = false;
            this.getData();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Something went wrong!";
          this.showsnackbar = true;
          console.log(err);
        });
    },
    deleteItem() {
      axios({
        url: "/pmr/remove",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: { id: this.curitem },
      })
        .then((response) => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.deleteDialog = false;
            this.getData();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.pmr-th {
  font-size: 15px !important;
  color: #ffffff !important;
  font-family: kumbhRegular;
}
</style>
